import {
  AtsFeedbackDetailFragment,
  DeleteAtsFeedbackDocument,
  DeleteAtsFeedbackMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteFeedback = (feedback: AtsFeedbackDetailFragment) => {
  const [deleteAtsFeedbackMutation, { loading }] = useMutation(DeleteAtsFeedbackDocument, {
    extractorFn: (data: DeleteAtsFeedbackMutation) => data.atsMutations.deleteAtsFeedback,
  })

  return {
    loading,
    deleteFeedback() {
      return deleteAtsFeedbackMutation({
        variables: { id: feedback.id },
        update(cache) {
          cache.evict({ id: cache.identify(feedback) })
        },
      })
    },
  }
}
